export default function redirectToAuth() {
  window.location.href = process.env.REACT_APP_HOMEPAGE_AUTH_URL || '';
}
